import {pxToEm} from "@insticator/insticator-ui";


export default theme => ({
    stack : {
        display: 'flex',
        '& > .MuiStack-root': {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            alignContent: 'flex-start',
            gap:pxToEm(8),
            alignSelf: 'stretch',
            flexWrap: 'wrap',
            '& > .stackitem' : {
                display: 'flex',
                height: pxToEm(32),
                padding: '0 12px',
                alignItems: 'center',
                gap: pxToEm(8),
                borderRadius: pxToEm(8),
                background: '#E7ECF7',
                marginTop: pxToEm(12),

            }
        },

    },
    // media queries
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [`@media only screen and (max-width:${pxToEm(900)})`]: {
        stack : {
            display: 'flex',
            '& > .MuiStack-root': {
                '& > .stackitem' : {
                   marginTop: '0 !important',

                }
            },

        },
    }
})